Vue.component('v-calc', {
  data: function () {
    return {
      periods: [],
      applyDate: '',
      dischargeDate: '',
      postError: {}
    }
  },
  mounted: function () {
    this.initDatepicker(true)
  },
  methods: {
    onAdd: function () {
      if (!this.validate()) return

      if (this.periods.length) {
        const lastPeriod = this.periods[this.periods.length - 1]
        this.periods.push({
          outOfJob: true,
          result: this.getDifference(lastPeriod.dischargeDate, this.applyDate, true)
        })
      }

      this.periods.push({
        applyDate: this.applyDate,
        dischargeDate: this.dischargeDate,
        result: this.getDifference(this.applyDate, this.dischargeDate),
        duration: this.calcDuration(this.applyDate, this.dischargeDate)
      })

      this.clear()
      const self = this
      window.setTimeout(function () {
        self.initDatepicker()
      }, 0)
    },
    onNew: function () {
      const self = this
      if (confirm('Все введенные данные будут удалены!\nНачать новый расчет?')) {
        this.clear()
        this.periods = []
        this.total = ''
        window.setTimeout(function () {
          self.initDatepicker()
        }, 0)
      }
    },
    getDifference: function (md1, md2, outOfJob) {
      const diff = this.calcDuration(md1, md2, outOfJob)
      if (diff === null) return diff
      return {
        days: diff.days(),
        months: diff.months(),
        years: diff.years()
      }
    },
    calcDuration: function (md1, md2, outOfJob) {
      const d1 = this.getMomentDate(md1)
      const d2 = this.getMomentDate(md2)
      const previouslyDuration = moment.duration(d2.diff(d1))
      const duration = outOfJob ? previouslyDuration.subtract(1, 'days') : previouslyDuration.add(1, 'days');
      if (duration.as('days') === 0) return null
      return duration;
    },
    getMomentDate: function (date) {
      const splittedStr = date.split('.')
      const day = splittedStr[0]
      const month = +splittedStr[1] - 1
      const year = splittedStr[2]
      return moment([year, month, day])
    },
    declOfNum(number, titles) {
      const num = Math.abs(number)
      const cases = [2, 0, 1, 1, 1, 2]
      return titles[
        num % 100 > 4 && num % 100 < 20
          ? 2
          : cases[num % 10 < 5 ? num % 10 : 5]
        ]
    },
    validate: function () {
      const d1 = this.getMomentDate(this.applyDate)
      const d2 = this.getMomentDate(this.dischargeDate)
      if (!this.applyDate || !this.dischargeDate) {
        this.postError = {
          applyDate: !this.applyDate,
          dischargeDate: !this.dischargeDate,
          text: !this.applyDate && !this.dischargeDate ? 'выберите даты' : `выберите дату ${!this.applyDate ? 'начала' : 'завершения'}`
        }
        return false
      }
      if (d2 < d1) {
        this.postError = {
          applyDate: true,
          dischargeDate: true,
          text: 'Увольнение должно быть позднее приема на работу'
        }
        return false
      } else
        return true
    },
    change: function (el) {
      this[el.id] = el.value
      this.postError = {}
    },
    initDatepicker: function (mounted) {
      let self = this
      let fields = $(this.$el).find('.hasDatepicker')
      fields.val('')
      if (!mounted) {
        try {
          fields.datetimepicker('destroy')
        } catch (err) {
          console.log(err)
        }
      }
      fields.datetimepicker({
          viewMode: 'days',
          format: 'DD.MM.YYYY',
          locale: 'ru',
          useCurrent:false,
        }).on('dp.change', function(e){
          self.change(this)
        }).on('dp.show', function(e){
          $(self.$el).find('.datepicker .prev').html('<svg width="11" height="18"><use xlink:href="#svg-arrow-prev-cal1-icon" /></svg>');
          $(self.$el).find('.datepicker .next').html('<svg width="11" height="18"><use xlink:href="#svg-arrow-next-cal1-icon" /></svg>');
        })
    },
    clear: function () {
      this.applyDate = ''
      this.dischargeDate = ''
      this.postError = {}
    }
  },
  computed: {
    total: function () {
      let sum = null
      if (this.periodItem) {
        sum = moment.duration(sum).add(this.periodItem)
      }
      this.periods.map((period) => {
        if (!period.duration) return false
        sum = moment.duration(sum).add(period.duration)
      })
      if (!sum) return null
      return {
        days: sum.days(),
        months: sum.months(),
        years: sum.years()
      }
    },
    periodItem: function () {
      let d1 = this.getMomentDate(this.applyDate)
      let d2 = this.getMomentDate(this.dischargeDate)
      if (d1.isValid() && d2.isValid()) {
        return moment.duration(d2.diff(d1)).add(1, 'days')
      }
      return null
    },
    periodSum: function () {
      if (this.periodItem) {
        return {
          days: this.periodItem.days(),
          months: this.periodItem.months(),
          years: this.periodItem.years()
        }
      }
      return null
    },
    preError: function () {
      let d1 = this.getMomentDate(this.applyDate)
      let d2 = this.getMomentDate(this.dischargeDate)
      if (d1.isValid() && d2.isValid()) {
        if (d2 < d1)
          return {
            applyDate: true,
            dischargeDate: true,
            text: 'Увольнение должно быть позднее приема на работу'
          }
      }
      return null
    },
    error: function () {
      return this.preError ? this.preError : this.postError
    }
  }
})
